// Journey 1 — the work lifecycle: a request enters, is scored, becomes a
// project, moves through gate reviews, and its risks become tracked actions.
import { ANCHORS } from '../../features/tours/tourAnchors.js';

export const j1Lifecycle = {
  id: 'j1-lifecycle',
  title: 'Follow the lifecycle',
  minutes: 4,
  steps: [
    {
      id: 'j1-queue',
      route: '/project-factory',
      routeKey: '/project-factory',
      anchor: ANCHORS.factoryQueue,
      title: 'The intake queue',
      body: 'The project factory queue holds every intake request waiting for a decision. Open one to see its score and why it landed where it did.',
    },
    {
      id: 'j1-intake-form',
      route: '/project-factory/requests/new',
      routeKey: '/project-factory/requests/new',
      anchor: ANCHORS.factoryIntakeForm,
      title: 'Where work begins',
      body: 'This is the intake form that starts a new piece of work. Fill it in and the request is scored and routed for you, with nothing lost in an inbox.',
    },
    {
      id: 'j1-scoring',
      route: '/project-factory',
      routeKey: '/project-factory',
      anchor: ANCHORS.factoryQueue,
      title: 'Scored and reviewed',
      body: 'Back in the queue, each request carries a scoring rubric result. A reviewer accepts, edits, or sends it back before it can become a project.',
    },
    {
      id: 'j1-projects',
      route: '/projects',
      routeKey: '/projects',
      anchor: ANCHORS.projectsList,
      title: 'From request to project',
      body: 'Approved requests graduate into projects. This list shows every active project with its current gate, its lifecycle stage, and its health.',
    },
    {
      id: 'j1-gate',
      route: '/projects',
      routeKey: '/projects',
      anchor: ANCHORS.projectsGate,
      title: 'Gates keep it honest',
      body: 'The current gate column points to each project’s next gate review, the checkpoint where leaders approve moving to the next stage.',
    },
    {
      id: 'j1-actions',
      route: '/actions',
      routeKey: '/actions',
      anchor: ANCHORS.actionCenter,
      title: 'Risks become actions',
      body: 'Risks and issues turn into tracked actions here. Every action carries an owner and a due date, so nothing quietly slips.',
    },
  ],
  closingNarrative:
    'That is one full lifecycle: a request comes in, gets scored, becomes a project, moves through gate reviews, and its risks become actions with owners. Closeout then captures the lessons learned so the next team starts ahead.',
};
